export const roundPrice = (number: number): number =>
  Math.round(number * 100) / 100;
